import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetAllCustomerApi, GetAllLaboursApi } from "../../ApiRequests";

export const fetchLabours = createAsyncThunk("fetch/Labours", async () => {
  try {
    const response = await GetAllLaboursApi();
    return response?.data?.data.payload;
  } catch (error) {
    console.log(error);
  }
  return [];
});

const LabourSlice = createSlice({
  name: "Labours",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLabours.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchLabours.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchLabours.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default LabourSlice.reducer;
